import { useEffect, useState } from "react";

// Computador/notebook: mesmo corte `lg` (1024 px) que o cardápio já usa para a
// grade de produtos. Abaixo disso (celular, tablet em pé) a sacola continua no
// rodapé + popup.
const CONSULTA = "(min-width: 1024px)";

function casaAgora() {
  try {
    return typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(CONSULTA).matches;
  } catch {
    return false;
  }
}

export default function useTelaLarga() {
  const [larga, setLarga] = useState(casaAgora);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(CONSULTA);
    const aoMudar = () => setLarga(mq.matches);
    aoMudar();
    // Safari < 14 só tem addListener/removeListener
    if (mq.addEventListener) mq.addEventListener("change", aoMudar);
    else mq.addListener(aoMudar);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", aoMudar);
      else mq.removeListener(aoMudar);
    };
  }, []);
  return larga;
}
